import React from 'react';
import { Stack, Typography, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ButtonsPrimary } from '../ComponentApp/buttoms';

const Onboarding = () => {
  const navigate = useNavigate();
  const theme = useTheme();

  return (
    <Stack
      spacing={3}
      sx={{
        backgroundColor: theme.palette.primary.blueLight,
        padding: '20px',
        borderRadius: '8px',
        boxShadow: '0px 0px 12px rgba(61, 64, 75, 0.18)',
      }}
      direction={{ md: 'row', xs: 'column' }}
      justifyContent='space-between'
      alignItems='center'>
      <Stack width={{ md: '90%', xs: '100%' }}>
        <Typography
          sx={{
            color: theme.palette.primary.main,
            fontSize: theme.typography.h1.fontSize,
            [theme.breakpoints.down('sm')]: {
              fontSize: theme.typography.titleText.fontSize,
            },
          }}>
          Tu registro está en proceso
        </Typography>
        <Typography
          sx={{
            mt: 2,
            fontSize: theme.typography.availableBalance.fontSize,
            color: theme.palette.primary.darkGray,
            fontWeight: 300,
          }}>
          Antes de realizar tu primera inversión necesitamos conocer un poco más de ti.
        </Typography>
        <Typography
          sx={{
            fontSize: theme.typography.availableBalance.fontSize,
            color: theme.palette.primary.darkGray,
            fontWeight: 300,
          }}>
          No olvides revisar tu correo y enviarnos los documentos solicitados para avanzar con tu
          cuenta y comenzar a invertir.
        </Typography>
      </Stack>

      <Stack width={{ md: '10%', xs: '100%' }}>
        {/*  <ButtonsPrimary
          name="Completar registro"
          onClick={() => navigate('/completeregistration')}
        /> */}
        <img width={'64px'} height={'64px'} src={'/assets/images/xclamation.svg'} alt='warning' />
      </Stack>
    </Stack>
  );
};

export default Onboarding;
